var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowCircle = function SvgIconArrowCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 31"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m18.208 15.781-.026.028-5.088 5.088a.902.902 0 0 1-1.302-1.248l.027-.027 4.46-4.461-4.46-4.461a.902.902 0 0 1 1.247-1.302l.028.027 5.088 5.088a.9.9 0 0 1 .263.62v.056a.9.9 0 0 1-.207.558z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28.5,
    height: 28.5,
    x: 29.25,
    y: 29.411,
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 14.25,
    transform: "rotate(-180 29.25 29.41)"
  })));
};
export { SvgIconArrowCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAzMCAzMSI+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJtMTguMjA4IDE1Ljc4MS0uMDI2LjAyOC01LjA4OCA1LjA4OGEuOTAyLjkwMiAwIDAgMS0xLjMwMi0xLjI0OGwuMDI3LS4wMjcgNC40Ni00LjQ2MS00LjQ2LTQuNDYxYS45MDIuOTAyIDAgMCAxIDEuMjQ3LTEuMzAybC4wMjguMDI3IDUuMDg4IDUuMDg4Yy4xNzEuMTcxLjI1OS4zOTUuMjYzLjYydi4wNTZhLjg5OS44OTkgMCAwIDEtLjIwNy41NThsLS4wMy4wMzRaIi8+PHJlY3Qgd2lkdGg9IjI4LjUiIGhlaWdodD0iMjguNSIgeD0iMjkuMjUiIHk9IjI5LjQxMSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS41IiByeD0iMTQuMjUiIHRyYW5zZm9ybT0icm90YXRlKC0xODAgMjkuMjUgMjkuNDEpIi8+PC9zdmc+";